import { useQuery } from "@tanstack/react-query";
import { getAllSuppliers } from "../../api/apiSuppliers";
import i18next from "i18next";

const useGetSuppliers = (page = 1, perPage = 15, filters = {}) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["suppliers", page, perPage, filters, i18next.language],
        queryFn: () => getAllSuppliers(page, perPage, filters),
    });

    return {
        suppliers: data?.data || {},
        meta: data?.data?.meta || {},
        error,
        isLoading,
        refetch,
    };
};

export default useGetSuppliers;
